import "./index.less";



// WEBPACK FOOTER //
// ./ecology9/wea-avatar/style/index.js